import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=53c935e2&scoped=true&"
import script from "./TV.vue?vue&type=script&lang=ts&"
export * from "./TV.vue?vue&type=script&lang=ts&"
import style0 from "./TV.vue?vue&type=style&index=0&id=53c935e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c935e2",
  null
  
)

export default component.exports